import { useMemo, useState } from "react";
import { useTranslation } from "react-i18next";

import { Divider } from "@mui/material";

import { Input, Text } from "@fragments";

import { getExerciseSections } from "../../../enums/exerciseOptions";

export default function ExerciseRegistry({
    configRef,
    enabled,
    onEnabledChange,
}) {
    const { t } = useTranslation("groupModals");

    const exerciseSections = useMemo(() => getExerciseSections(t), [t]);

    return (
        <div className="exercise-registry mt-4 mb-1">
            <div className="exercise-registry__header">
                <Text.h4
                    className="bold"
                    value={t("publishPost.exercise.title")}
                />
                <Input.Switch value={enabled} onInput={onEnabledChange} />
            </div>

            {enabled && (
                <>
                    <Divider className="mt-1" />
                    <div className="exercise-registry__body">
                        {exerciseSections.map((section) => (
                            <Section
                                key={section.path}
                                section={section}
                                configRef={configRef}
                            />
                        ))}
                    </div>
                </>
            )}
        </div>
    );
}

function Section({ section, configRef }) {
    const Icon = section.icon;
    const [value, setValue] = useState(
        configRef.current.activity?.[section.path]
    );

    function handleSelect(next) {
        configRef.current.activity = {
            ...configRef.current.activity,
            [section.path]: next,
        };
        setValue(next);
    }

    return (
        <div className="exercise-section mt-4 mb-1">
            <Text.h4
                className="exercise-section__title"
                left={<Icon />}
                value={section.title}
            />

            <div className="exercise-section__options">
                {section.options.map((option) => (
                    <Option
                        key={String(option.value)}
                        title={option.title}
                        active={value === option.value}
                        onClick={() => handleSelect(option.value)}
                    />
                ))}

                {section.allowCustom && (
                    <Input.Integer
                        value={value || ""}
                        onInput={handleSelect}
                        placeholder={section.customPlaceholder}
                        label={section.customLabel}
                        fullWidth
                        max={section.customMax}
                    />
                )}
            </div>
        </div>
    );
}

function Option({ title, active, onClick }) {
    return (
        <div
            className={
                "exercise-option" + (active ? " exercise-option--active" : "")
            }
            onClick={onClick}
        >
            <Text.span value={title} />
        </div>
    );
}
